import { currentLocale, intlLocaleFor } from "../i18n";

const cache = new Map<string, Intl.DisplayNames | null>();

/**
 * An ISO 3166-1 alpha-2 code as a country name in the UI language ("MY" →
 * "Malaysia" / "มาเลเซีย"), through `intlLocaleFor` (never `bm` / `tet` to
 * Intl). Falls back to the code when the runtime has no name for it.
 */
export function regionName(code: string | null | undefined): string {
	if (!code) return "";
	const locale = intlLocaleFor(currentLocale());
	let names = cache.get(locale);
	if (names === undefined) {
		try {
			names = new Intl.DisplayNames([locale], { type: "region" });
		} catch {
			names = null;
		}
		cache.set(locale, names);
	}
	try {
		return names?.of(code.toUpperCase()) ?? code;
	} catch {
		return code;
	}
}
